module.exports = __webpack_public_path__ + "static/img/glxt_05.e556cfd8.png";